import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// quotations — ใบเสนอราคา (Quotation)
// ============================================================================
export const quotations = sqliteTable("sales_quotations", {
  id: text("id").primaryKey(), // ULID
  quotationNo: text("quotation_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  partyType: text("party_type", {
    enum: ["customer"],
  }).notNull().default("customer"),
  partyId: text("party_id").notNull(),
  quotationDate: text("quotation_date").notNull(),
  expiryDate: text("expiry_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  total: real("total").notNull().default(0),
  status: text("status", {
    enum: ["draft", "submitted", "approved", "converted", "expired", "cancelled"],
  })
    .notNull()
    .default("draft"),
  convertedToInvoiceId: text("converted_to_invoice_id"),
  convertedToOrderId: text("converted_to_order_id"),
  remarks: text("remarks"),
  // Doctype Admin Epic (#347) issue B1 (#356) — JSON blob of custom field
  // values. Written by `<DoctypeForm>` (B2) after `buildCustomFieldSchema`
  // (A7) validates the values against the custom field definitions for the
  // `quotation` doctype. Nullable so existing rows remain valid — the NULL
  // literal is the "no custom data" sentinel. Never read with `JSON.parse`
  // without going through `parseCustomData` (A7) so stale shapes stay
  // defensive.
  customData: text("custom_data"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  companyStatusIdx: index("qt_company_status_idx").on(table.companyId, table.status, table.quotationDate),
  companyPartyIdx: index("qt_company_party_idx").on(table.companyId, table.partyId),
  convertedIdx: index("qt_converted_idx").on(table.convertedToInvoiceId),
  convertedOrderIdx: index("qt_converted_order_idx").on(table.convertedToOrderId),
}));

// Type exports
export type Quotation = typeof quotations.$inferSelect;
export type NewQuotation = typeof quotations.$inferInsert;
